export const en = {
  home: {
    pageTitle: "João Mago | Senior Full Stack Engineer",
    pageDescription:
      "João Mago is a Senior Full Stack Engineer based in Brazil, working remotely on web and mobile products with TypeScript, Node.js, React, Next.js, and PostgreSQL.",
    hello: "Hello, I'm",
    myName: "João Mago.",
    devInfo: "Senior Full Stack Engineer | Senior Software Engineer",
    locationRemote: "Based in Brazil · Open to remote opportunities",
    navigationLabel: "Main navigation",
    navigationAbout: "Profile",
    navigationSkills: "Skills",
    navigationContact: "Contact",
    languageLabel: "Language",
    introduction: "Profile",
    introductionName:
      "Senior Full Stack Engineer with {{years}} years of experience",
    introductionInfo:
      "I build web and mobile products across SaaS and fintech, working across the product lifecycle from architecture and implementation to infrastructure, deployment, and production monitoring. I also bring experience leading technical teams.",
    profileImageAlt: "João Mago's GitHub profile photo",
    skills: "Technical skills",
    coreSkills: "Core stack",
    additionalSkills: "Additional technologies and tools",
    aiDevelopmentSkills: "AI-assisted development",
    contact: "Contact",
    contactPrompt: "Get in touch or find me online.",
    email: "Email",
    linkedin: "LinkedIn profile",
    github: "GitHub profile",
  },
};
